<script lang="ts">
  import { fade } from 'svelte/transition';
  import { useModal } from '../../etc/hooks/useModal';
  import { Container } from '../../services/container';
  import { AppState } from '../../etc/stores';
  import { isMobile } from '../../etc/utils';
  import { Auth } from '../../services/auth';
  import Toast from './Toast.svelte';

  const { close } = useModal();
  const auth = Container.get(Auth);

  $: component = $AppState.website.fullscreenModal.component;
  $: isVisible = $AppState.website.fullscreenModal.isVisible;
  $: options = $AppState.website.fullscreenModal.options || {};
</script>

{#if isVisible && !!component}
  <div class="twism-fullscreenmodal-wrapper {auth.provider}">
    {#if !options.hideScreenLocker}
      <div
        class="twism-fullscreenmodal-screenlocker {isVisible && !!component
          ? '-twism-modal-visible'
          : ''}"
        on:click={() => !options.disableScreenLockerCloseAction && close()}
        out:fade
      />
    {/if}
    <div class="twism-fullscreenmodal-container">
      <div
        style={`position: relative; ${
          isMobile() ? 'width: 100%; height: 100%;' : ''
        }`}
      >
        <Toast />

        <svelte:component this={component} {...options.props} />
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  .twism-fullscreenmodal {
    &-wrapper {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;

      &.wix {
        z-index: calc(var(--above-all-z-index) - 2);
      }

      &.woocommerce,
      &.shopify,
      &.bigcommerce {
        z-index: 1000002;
      }
    }

    &-screenlocker {
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0;
      transition: opacity 0.5s ease-in-out;

      &.-twism-modal-visible {
        opacity: 0.7;
      }
    }

    &-container {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      /*
       we may have to change this flex configuration later
       in order to be dinamically
      */
      display: flex !important;
      justify-content: center;
      align-items: center;
    }
  }

  :global(.twism-fullscreenmodal-container > *) {
    pointer-events: all;
  }
</style>
